import React, { useState, useEffect } from "react";
import {
	fetchNewsById,
	updateNewsComment,
	deleteNews,
} from "../../ApiController/newsApi";
import "./NewsDisplay.css";

const NewsDisplay = ({ userId }) => {
	const [newsList, setNewsList] = useState([]);
	const [editingNewsId, setEditingNewsId] = useState(null);
	const [editingText, setEditingText] = useState("");

	useEffect(() => {
		const fetchNews = async () => {
			try {
				const userId = sessionStorage.getItem("userId");
				const fetchedNewsData = await fetchNewsById(userId);
				setNewsList(fetchedNewsData);
			} catch (error) {
				console.error("Misslyckades med att hämta nyheter:", error);
			}
		};

		fetchNews();
	}, [userId]);

	const handleEdit = (newsItem) => {
		setEditingNewsId(newsItem.id);
		setEditingText(newsItem.comment);
	};
	const handleSave = async (newsId) => {
		try {
			await updateNewsComment(newsId, editingText);

			setNewsList(
				newsList.map((newsItem) => {
					if (newsItem.id === newsId) {
						return { ...newsItem, comment: editingText };
					}
					return newsItem;
				})
			);

			setEditingNewsId(null);
			setEditingText("");
		} catch (error) {
			console.error("Misslyckades med att spara ändringen:", error);
			alert("Misslyckades med att spara ändringen");
		}
	};

	const handleCancel = () => {
		setEditingNewsId(null);
	};

	const handleDelete = async (newsId) => {
		const isConfirmed = window.confirm(
			"Är du säker på att du vill ta bort denna nyhet?"
		);

		if (isConfirmed) {
			try {
				await deleteNews(newsId);
				setNewsList(newsList.filter((newsItem) => newsItem.id !== newsId));
			} catch (error) {
				console.error(
					`Misslyckades med att ta bort nyheten med ID ${newsId}:`,
					error
				);
				alert("Misslyckades med att ta bort nyheten");
			}
		}
	};

	return (
		<div className="news-display-container">
			{newsList.length > 0 ? (
				<ul>
					{newsList.map((newsItem, index) => (
						<li key={index} className="news-item">
							<div className="news-content">
								{editingNewsId === newsItem.id ? (
									<div className="textarea-item">
										<textarea
											value={editingText}
											onChange={(e) => setEditingText(e.target.value)}
										/>
										<button
											onClick={() => handleSave(newsItem.id)}
											className="custom-btn"
										>
											Spara
										</button>
										<button
											onClick={handleCancel}
											className="custom-btn"
										>
											Avbryt
										</button>
									</div>
								) : (
									<span>{newsItem.comment}</span>
								)}
							</div>
							<div className="news-actions">
								{editingNewsId !== newsItem.id && (
									<button
										onClick={() => handleEdit(newsItem)}
										className="custom-btn"
									>
										Ändra
									</button>
								)}
								<button
									onClick={() => handleDelete(newsItem.id)}
									className="custom-btn"
								>
									Ta bort
								</button>
							</div>
						</li>
					))}
				</ul>
			) : (
				<p>Inga aktuella nyheter tillgängliga.</p>
			)}
		</div>
	);
};

export default NewsDisplay;
